import './BackButton.scss';

import { useNavigate } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <button className='backButton' onClick={goBack}>
      <svg width='18' height='18' viewBox='0 0 24 24' fill='#515592'>
        <path d='M15.4142 6.58579C15.7893 6.96086 15.8109 7.55348 15.4792 7.95376L15.4142 8.02513L10.4394 13L15.4142 17.9749C15.7893 18.35 15.8109 18.9426 15.4792 19.3429L15.4142 19.4142C15.0391 19.7893 14.4465 19.8109 14.0462 19.4792L13.9749 19.4142L8.29289 13.7322C7.91785 13.3571 7.89622 12.7645 8.2179 12.3642L8.29289 12.2929L13.9749 6.61091C14.3654 6.22039 14.9987 6.22039 15.3892 6.61091L15.4142 6.58579Z' />
      </svg>
    </button>
  );
};

export default BackButton;